import { Dispatch } from "react";
import { AnyAction } from "redux";
import { getSurveyTextAnswers } from "../../../../../../../../connection/moderator";
import { appendTextAnswers, setTextAnswers } from "../../../../../../../../store/actions/admin/surveys";
import { TextAnswer } from "@/types/working-model";

export type TextAnswerLoaderFuncProps = {
	questionId: number;
	limit: number;
	offset?: number;
	token: string;
	sessionUuid: string;
	channel: number;
	dispatch?: Dispatch<AnyAction>;
}

class TextAnswerLoader {
	loading: number[] = [];
	token = '';
	sessionUuid = '';
	channel = 0;

	dispatch: Dispatch<AnyAction> = () => { };

	load = (props: TextAnswerLoaderFuncProps): Promise<{ total: number; results: TextAnswer[]; } | void> => {
		const { questionId, limit = 100, token, sessionUuid, channel, dispatch, offset = 0 } = props;
		if (this.loading.includes(questionId)) return Promise.resolve();

		this.loading.push(questionId);
		this.token = token;
		this.sessionUuid = sessionUuid;
		this.channel = channel;

		if (dispatch) {
			this.dispatch = dispatch;
		}

		return getSurveyTextAnswers({
			token,
			sessionUuid,
			channel,
			question_id: questionId,
			limit,
			offset,
		}).then(res => {
			if (dispatch) {
				dispatch(setTextAnswers(questionId, res.results, res.total));
			} else {
				return res;
			}
		}).catch(e => {
			console.error(e);
		}).finally(() => {
			this.loading = this.loading.filter(id => id !== questionId);
			return;
		});
	};

	next = async ({ offset, limit, questionId }: { questionId: number; offset: number; limit: number }): Promise<void> => {
		if (this.loading.includes(questionId)) return;
		const results = await this.load({
			questionId,
			limit,
			offset,
			token: this.token,
			sessionUuid: this.sessionUuid,
			channel: this.channel,
		});
		if (!results) return;
		this.dispatch(appendTextAnswers(questionId, results?.results || [], results?.total || 0));
	};
}

export default new TextAnswerLoader();